import React, { Component } from 'react'
import '../App.css'
import {Nav} from '../components/Nav'
import Home from './Home'
import {Location} from '../components/Location'
import {About} from '../components/About'
import {HashRouter,Route,Switch} from 'react-router-dom'


class App extends Component {

    render() {
        return (
           <HashRouter>
              <div className="App">
                <div className="App-header">
                  <h2>SmartCitizen ReactJS/Redux/Routerv4/Leaflet</h2>
                </div>
                 <Nav />
                 <div className="container">
                      <Switch>
                          <Route exact path='/' component={Home} />
                          <Route path='/location' component={Location} />
                          <Route path='/about' component={About} />
                          <Route render={()=> {return <p>Not found</p>}} />
                      </Switch>
                 </div>
              </div>
            </HashRouter>
        );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js